import { Injectable } from '@angular/core';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetDashboardWidgetConfigurationResponse, SaveDashboardWidgetConfigurationResponse } from '@dashboard-widget/dashboard-widget.types';

@Injectable({
  providedIn: 'root'
})
export class DashboardWidgetConfigService {

  constructor(private readonly http: HttpClient, private readonly urlBuilder: UrlBuilderService) {}

  private readonly baseUri = 'dashboardwidget/config';

  private uri = (path?: string) => this.urlBuilder.getUrl(`${this.baseUri}/${path || ''}`);

  getConfig(dashboardWidgetId: number): Observable<GetDashboardWidgetConfigurationResponse> {
    const url = this.uri();
    const params = new HttpParams().set('dashboardWidgetId', `${dashboardWidgetId}`);
    return this.http
      .get<GetDashboardWidgetConfigurationResponse>(url, { params: params });
  }

  saveConfig(dashboardWidgetId: number, config: any): Observable<SaveDashboardWidgetConfigurationResponse> {
    const url = this.uri();
    return this.http
      .post<SaveDashboardWidgetConfigurationResponse>(url, { DashboardWidgetId: dashboardWidgetId, ConfigurationObject: config });
  }

}
